import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Picture = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M15.8365 19.125L12.8221 16.1106M19.125 16.3846L15.8365 13.0962L12.8221 16.1106M12.8221 16.1106L8.16346 11.4519L5.42308 14.1923L4.875 14.7404M4.875 14.7404L4.875 7.06731C4.875 5.85653 5.85653 4.875 7.06731 4.875L16.9327 4.87502C18.1435 4.87502 19.125 5.85655 19.125 7.06733L19.125 16.9327C19.125 18.1435 18.1435 19.125 16.9327 19.125L7.06731 19.125C5.85653 19.125 4.875 18.1435 4.875 16.9327L4.875 14.7404ZM16.9327 8.71154C16.9327 9.61962 16.1965 10.3558 15.2885 10.3558C14.3804 10.3558 13.6442 9.61962 13.6442 8.71154C13.6442 7.80345 14.3804 7.0673 15.2885 7.0673C16.1965 7.0673 16.9327 7.80345 16.9327 8.71154Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Picture };